export type DataSourceType = 'api' | 'csv'

export interface IMetricsMapping {
    value: string,
    label: string
}

export interface IGpsIntegration {
    key: string,
    url: string,
    type: string,
    name: string
}

export interface IConfigureMetric {
    metric?: string,
    extractionApproach: MappingMode,
    extractionText?: string,
    conversion?: string,
    units?: string,
    source_gps_unit?: string
}

export interface ISampleDataPointDataType {
    field: string
    value: number
}

export enum MappingMode {
    SLUG = 'slug',
    BUILTIN_FUNCTION = 'builtin_function',
    USER_FORMULA = 'user_formula'
}

export interface IGpsMetricMappingValidation {
    all_valid: boolean;
    date_format: string;
    message: string;
    validation_results: {
        conversion: string;
        error: string | null,
        mapping: string;
        mapping_mode: MappingMode;
        metric_id: number;
        valid: boolean;
    }[]
}

export interface IGpsMetricMappingSample {
    headers: string[],
    rows: object[],
    source_key: string,
    source_type: string
}